import React from 'react';

import { SVGComponentProps } from './svg.types';

const AudioSpeakerSVG = ({
  fill = '#878A92',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps): JSX.Element => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 14"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M8.00482 11.9872C8.00482 12.2691 7.84196 12.5252 7.58709 12.6447C7.48855 12.6913 7.38296 12.7138 7.27806 12.7138C7.11193 12.7138 6.94735 12.6567 6.81442 12.5465L2.84219 9.25492H0.726585C0.325372 9.25526 0 8.92972 0 8.5285V5.63369C0 5.2323 0.325372 4.90693 0.726585 4.90693H2.84237L6.81459 1.61537C7.03162 1.43549 7.33257 1.39714 7.58727 1.51752C7.84196 1.63704 8.00499 1.89328 8.00499 2.17497L8.00482 11.9872ZM10.7971 10.8519C10.7794 10.8531 10.7624 10.8537 10.7449 10.8537C10.5529 10.8537 10.3679 10.7779 10.2312 10.641L10.134 10.5435C9.87915 10.2892 9.84922 9.88623 10.0638 9.59697C10.608 8.86334 10.8952 7.99367 10.8952 7.08135C10.8952 6.10008 10.5691 5.17968 9.95206 4.41956C9.71715 4.13065 9.73882 3.71103 10.0021 3.44791L10.0991 3.35075C10.2442 3.2056 10.4387 3.1265 10.6492 3.13905C10.8542 3.14937 11.0456 3.24585 11.1756 3.40475C12.0316 4.45206 12.4837 5.72363 12.4837 7.08153C12.4837 8.34621 12.0838 9.55002 11.3272 10.5623C11.2008 10.731 11.0075 10.8369 10.7971 10.8519ZM13.8012 13.0973C13.6698 13.2526 13.4797 13.3458 13.2763 13.3544C13.2663 13.3547 13.2562 13.3551 13.2459 13.3551C13.0534 13.3551 12.8687 13.2791 12.732 13.1424L12.6366 13.0469C12.3698 12.7804 12.3518 12.354 12.5943 12.0655C13.7661 10.6718 14.4117 8.90186 14.4117 7.08135C14.4117 5.18776 13.7205 3.36485 12.466 1.94848C12.2116 1.66094 12.2245 1.22568 12.4952 0.953965L12.5905 0.85852C12.7318 0.71647 12.9155 0.638223 13.1262 0.64493C13.3262 0.650605 13.5153 0.738999 13.6483 0.888615C15.1647 2.59596 16 4.79549 16 7.08135C16.0003 9.28071 15.2194 11.4173 13.8012 13.0973Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default AudioSpeakerSVG;
